import { ContactStatus, IContact } from 'clickNgo/entities/contact'
import { PartnerHierarchyType } from 'clickNgo/entities/partner/configs'
import { IPartner } from 'clickNgo/entities/partner/models'
import {
  getImportantRolesToReassign,
  getUniqueRolesToReassign,
} from 'clickNgo/features/contact/contactReassignment/lib'
import { getContactsImportantRoles } from 'clickNgo/features/contact/contactRelinking/contactRelinkingValidationModal/components/steps/welcomeStep/helpers/getContactsImportantRoles'
import { hierarchyTypesForAskingHowRemoveRoles } from 'clickNgo/features/contact/contactRelinking/contactRelinkingValidationModal/configs'

interface IDetermineRolesToReassign {
  contact: IContact
  targetPartner: IPartner
  availableContacts: IContact[]
  targetPartnerContacts: IContact[]
}

const checkAskingHowRemoveUniqueRoles = (
  currentPartnerHierarchyType: PartnerHierarchyType,
  targetPartnerHierarchyType: PartnerHierarchyType
) => {
  return (
    hierarchyTypesForAskingHowRemoveRoles.includes(currentPartnerHierarchyType) &&
    hierarchyTypesForAskingHowRemoveRoles.includes(targetPartnerHierarchyType)
  )
}
export const determineRolesToReassign = ({
  contact,
  targetPartner,
  availableContacts,
  targetPartnerContacts,
}: IDetermineRolesToReassign) => {
  const contactImportantRoles = getImportantRolesToReassign(contact.hpRoles)
  const availableContactsImportantRoles = getContactsImportantRoles(availableContacts)

  const rolesToReassign = contactImportantRoles.filter(
    (r) => !availableContactsImportantRoles.some((a) => a.role === r.role)
  )

  const uniqueRolesToReassign = getUniqueRolesToReassign(contact.hpRoles)
  const rolesToCheck = uniqueRolesToReassign.map((r) => r.role)

  const isAskingHowRemoveUniqueRoles =
    uniqueRolesToReassign.length > 0 &&
    checkAskingHowRemoveUniqueRoles(contact.hierarchyType, targetPartner.hierarchyType)

  const targetContactsWithUniqueRoles = targetPartnerContacts
    .filter((cn) => cn.status !== ContactStatus.Inactive)
    .filter((cn) => cn.hpRoles.some((role) => rolesToCheck.includes(role)))

  const targetPartnerContactsRoles = targetContactsWithUniqueRoles.map((cn) => ({
    rolesForRemoving: cn.hpRoles.filter((role) => rolesToCheck.includes(role)),
    contact: cn,
  }))

  const isNeedReassignRoles = rolesToReassign.length > 0
  const isNeedReassignUniqueRoles = uniqueRolesToReassign.length > 0

  return {
    rolesToReassign,
    uniqueRolesToReassign,
    targetPartnerContactsRoles,
    isAskingHowRemoveUniqueRoles,
    isNeedReassignRoles,
    isNeedReassignUniqueRoles,
  }
}
